import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Amplify from 'aws-amplify';
import './css/normalize.css';
import './css/style.css';
import App from './App';
import apiConfig from './utils/apiConfig';
import { GlobalStateProvider } from './store';
import Layout from 'components/Layout';
import { LocalizationProvider } from './localization';
// Configure Amplify
Amplify.configure(apiConfig);

ReactDOM.render(
  <React.StrictMode>
    <GlobalStateProvider>
      <LocalizationProvider>
        <Layout>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Layout>
      </LocalizationProvider>
    </GlobalStateProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
